import moment from 'moment'
import { estate } from '../constants'

const MS_IN_A_DAY = 86400000
const MS_IN_A_MINUTE = 60000

/**
 * Gives the current month back
 */
const currentMonth = () => new Date().getMonth() + 1

/**
 * Gives the current year back
 */
const currentYears = () => new Date().getFullYear()

const addZeroBefore = (n) => {
    return (n < 10 ? '0' : '') + n
}
const DatesUtils = {
    /**
     * Gives the current month back
     */
    currentMonth,

    /**
     * Gives the current year back
     */
    currentYears,

    /**
     * Gets the number of days a month has
     * @param {number} month
     * @param {year} year
     */
    daysInAMonth: (month = currentMonth(), year = currentYears()) => new Date(year, month, 0).getDate(),

    /**
     * Gets a date formatted as `YYYY-MM-DD hh:mm:ss`
     * @param {Date/number} date
     */
    formatDB: (date) => {
        if (!date) {
            return null
        }

        const newDate = new Date(date)
        return `${newDate.getUTCFullYear()}-${addZeroBefore(newDate.getUTCMonth() + 1)}-${addZeroBefore(newDate.getUTCDate())} ${addZeroBefore(
            newDate.getUTCHours()
        )}:${addZeroBefore(newDate.getUTCMinutes())}:${addZeroBefore(newDate.getUTCSeconds())}`
    },

    /**
     * Gets a date with ISO format
     * @param {Date|Number} date
     */
    formatISO(date) {
        if (!date) {
            return null
        }

        return moment(new Date(date)).format('YYYY-MM-DD[T]hh:mm:ss[.000Z]')
    },
    /**
     * Gets a date formatted as `DD/MM hh:mm`
     * @param {Date|Number} date
     */
    formatUIShort(date) {
        if (!date) {
            return null
        }

        return moment(new Date(date)).format('DD/MM hh:mm')
    },
    /**
     * Gets a date formatted as `D/MM/YYYY H:mm:ss`
     * @param {Date|Number} date
     */
    formatEU(date) {
        if (!date) {
            return null
        }
        const myTimeDifference = new Date().getTimezoneOffset() 
        return moment(new Date(date)).subtract(myTimeDifference, 'minutes').format('D/MM/YYYY H:mm:ss')
    },

    /**
     * Sets a date to be at midnight
     * @param {Date|Number} [date]
     */
    midnight: (date) => {
        const midnight = new Date(date) || new Date()
        midnight.setHours(0)
        midnight.setMinutes(0)
        midnight.setSeconds(0)
        midnight.setMilliseconds(0)
        return midnight.getTime()
    },

    /**
     * Substracts a number of days to a date
     * @param {Number} date
     * @param {Date|Number} days
     */
    minusDays: (date, days) => {
        const ts = date instanceof Number ? date : new Date(date).getTime()
        return ts - MS_IN_A_DAY * days
    },

    /**
     * Substracts a minutes of days to a date
     * @param {Number} date
     * @param {Date|Number} min
     */
    minusMinutes: (date, min) => {
        const ts = date instanceof Number ? date : new Date(date).getTime()
        return ts - MS_IN_A_MINUTE * min
    },

    /**
     * Adds a number of days to a date
     * @param {Number} date
     * @param {Date|Number} days
     */
    plusDays: (date, days) => {
        const ts = date instanceof Number ? date : new Date(date).getTime()
        return ts + MS_IN_A_DAY * days
    },

    /**
     * Adds a minutes of days to a date
     * @param {Number} date
     * @param {Date|Number} min
     */
    plusMinutes: (date, min) => {
        const ts = date instanceof Number ? date : new Date(date).getTime()
        return ts + MS_IN_A_MINUTE * min
    },

    /**
     * Gets current timestamp in millisecons
     */
    now: () => new Date().getTime(),

    /**
     * Transforms a timestamp in millis to a timestamps in seconds
     * @param {Number} timestamp
     */
    timestampSeconds: (timestamp) => Math.trunc(timestamp / 1000),

    /**
     * Transforms an UTC date to timestamp
     */
    UTCDateToTimestamp: (date) => {
        // It is a formatted string
        if (typeof date === 'string') {
            return moment.utc(date).unix() * 1000
        }

        // It is a timestamp
        if (typeof date === 'number') {
            // Timestamp is in seconds
            if (date.toString().length === 10) {
                return date * 1000
            }

            return date
        }

        return date
    },

    /**
     * Transforms date to UTC date
     */
    toUTCDate: (date) => {
        return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds()))
    },

    /**
     * 
     * @param {number} lastContact 
     * @returns 
     */
    isOffline(lastContact) {
        return DatesUtils.now() - lastContact > estate.deviceActuallyOfflineMS;
    }
}

export default DatesUtils
